import PropTypes from 'prop-types'
import { useRef, useState } from 'react'
import { useLocation } from 'react-router'
import { getIsActiveFollowRoute } from '../../../helpers/common'
import { Dropdown, positionDropdown } from '../../dropdown'
import { DropdownList } from '../../dropdown/DropdownList'
import { HandleClickOutside } from '../../HandleClickOutside'
import { Element } from '../../html/element'
import { Icon } from '../../html/icon'
import classes from './index.module.scss'

export const More = ({ data }) => {
  const ref = useRef()
  const childrenRef = useRef()
  const [isShow, setIsShow] = useState(false)
  const location = useLocation()
  const isActive = getIsActiveFollowRoute(location, null, data)

  const onClick = () => {
    setIsShow(!isShow)
  }

  return (
    <>
      <Element
        ref={ref}
        elementName="li"
        className={classes.item}
        style={{
          borderLeftWidth: 1,
          borderLeftStyle: 'solid',
          borderLeftColor: '#FFFFFF',
          backgroundColor: isActive ? '#ECF3FF' : '#EBEBEB',
          borderBottomWidth: isActive && 4,
          borderBottomStyle: isActive && 'solid',
          borderBottomColor: isActive && '#2C73E8',
          padding: '6px 16px',
        }}
        onClick={onClick}
      >
        <Icon className="icon-menu-dot-ver" style={{ lineHeight: 0 }} />
      </Element>

      {isShow && (
        <Dropdown parentRef={ref} position={positionDropdown.BOTTOM_END_LEFT}>
          <HandleClickOutside
            exceptRef={[ref, childrenRef]}
            handleClickOutside={() => {
              setIsShow(false)
            }}
          >
            <DropdownList
              childrenRef={childrenRef}
              data={data.map((item) => {
                return {
                  ...item,
                  isActive: getIsActiveFollowRoute(
                    location,
                    item.route,
                    item.children,
                  ),
                  isI18n: true,
                }
              })}
            />
          </HandleClickOutside>
        </Dropdown>
      )}
    </>
  )
}

More.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      isI18n: PropTypes.bool,
      route: PropTypes.string,
    }),
  ).isRequired,
}
